module.exports = __webpack_public_path__ + "img/INNBeauty3.59c3e5ff.jpg";